<template>
  <b-modal
      id="addCommercialConfig"
      size="lg"
      v-if="activeService">
    <template
        slot="modal-header"
        slot-scope="{ close }">
      <div class="container-fluid">
        <div class="row">
          <div class="col-9 my-auto">
            <h5 class="modal-title">Add Commercial Config</h5>
          </div>
          <div class="col-3 my-auto">
            <div>
              <div>
								<span>
									<a class="close">
										<i
                        class="far fa-times-circle fa-2x"
                        @click="close()"
                        id="closeAddCommercialConfig"
                        aria-label="Close"></i>
									</a>
								</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

		<template slot="default">
			<b-card

				class="mt-2">
				<div class="mt-2 W-100">
					<div class="py-2">
						<p class="d-inline-block font-weight-bold mb-0">Effective From:</p>
						<el-date-picker
							v-model="pickerDate"
							format="dd.MM.yyyy"
							class="float-right"
							type="date"></el-date-picker>
					</div>
				</div>
				<hr class="mt-2" />
				<div class="row text-left">
					<div class="col-sm-6">
						<!-- left col1 6 start -->
						<div class="row">
							<div class="col-12">
								<p class="font-weight-bold text-left pl-2">
									Commercial Percentage
								</p>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<div class="row">
									<div class="col-9">
										<input
											v-model="config.CommercialPercentage"
											type="range"
											class="w-100 slider"
											min="0"
											max="100"
											step="1" />
									</div>
									<div class="col-3">
										<input
											v-model="config.CommercialPercentage"
											type="number"
											class="w-100 border border-secondary brs text-center" />
										<!-- must have a % sign after the integer and must default to 100%-->
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- left col1 6 end -->
					<div class="col-sm-6">
						<!-- right col1 6 start -->
						<div class="col-12">
							<p class="font-weight-bold text-left pl-2">CCL Exemption Type</p>
						</div>
						<div class="col-12">
							<div class="btn-group d-block w-100">
								<div class="form-group my-auto">
									<b-form-select
										v-model="config.CclExemptionType"
										class="form-control"
										name="selection"
										required>
										<option value="NotExempt">Not Exempt</option>
										<option value="Charity">Charity</option>
										<option value="Domestic">Domestic</option>
										<option value="Usage">Usage</option>
										<option value="ClimateChangeAgreementInPlace">
											Climate change agreement in place
										</option>
									</b-form-select>
								</div>
							</div>
						</div>
					</div>
					<!-- right col1 6 end -->
				</div>
				<hr class="mt-4" />
				<div class="row text-left">
					<div class="col-sm-6">
						<!-- left col2 6 start -->
						<div class="row">
							<div class="col-12">
								<p class="font-weight-bold text-left pl-2">
									CCA Reduction Percentage
								</p>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<div class="row">
									<div class="col-9">
										<input
											v-model="config.CcaReductionPercentage"
											type="range"
											class="w-100 slider"
											min="0"
											max="100"
											step="1" />
									</div>
									<div class="col-3">
										<input
											v-model="config.CcaReductionPercentage"
											type="number"
											class="w-100 border border-secondary brs text-center" />
										<!-- must have a % sign after the integer and must default to 100% -->
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- left col2 6 end -->
					<div class="col-sm-6">
						<!-- right col2 6 start -->
						<div class="col-12">
							<p class="font-weight-bold text-left pl-2">
								CCA Agreement Description
							</p>
						</div>
						<div class="col-12">
							<textarea
								v-model="config.CcaAgreementDescription"
								class="form-control z-depth-1"
								id="exampleFormControlTextarea5"
								rows="3"></textarea>
						</div>
					</div>

					<!-- right col2 6 end -->
				</div>

				<div
					class="row text-left mt-4 mb-4"
					v-if="isHH">
					<div class="col-sm-6">
						<p class="font-weight-bold text-left pl-2">HH NHH Mapping</p>
						<div class="btn-group d-block w-100">
							<div class="form-group my-auto">
								<b-form-select
									v-model="config.HhNhhMappingId"
									class="form-control"
									name="selection"
									required>
									<option :value="null">Not Applicable</option>
									<option
										v-for="mapping in HHNHHMappings"
										:key="mapping.value"
										:value="mapping.value">
										{{ mapping.label }}
									</option>
								</b-form-select>
							</div>
						</div>
					</div>
				</div>

				<div class="row mt-3" v-if="activeServiceType !== 'Electricity' || !isHH">
					<div class="col-auto m-2">
						<label class="checkbox">
							<input
								type="checkbox"
								v-model="overrideIndustry" />
							<span class="default"></span>
						</label>
						<span v-if="activeServiceType === 'Electricity'" class="d-inline pl-2">Override Industry Eac?</span>
						<span v-if="activeServiceType === 'Gas'" class="d-inline pl-2">Override Industry AQ?</span>
					</div>
				</div>
				<div v-if="overrideIndustry">
					<hr
						class="mt-4" />
					<div
						class="row text-left"
						v-if="activeServiceType === 'Electricity' && !isHH">
						<div class="col-sm-4">
							<!-- left col4 start -->
							<div class="row">
								<div class="col-12">
									<p class="font-weight-bold text-left pl-2">
										Meter Point Billing EAC
									</p>
								</div>
							</div>
							<div class="row">
								<div class="col-12">
									<div class="d-block w-100">
										<input
											type="number"
											class="w-100 sh border border-secondary brs text-center"
											v-model="config.MeterPointBillingEac"
											v-if="config.EacLevel === 'MeterPoint'"
											@change="updateBillingEacs(config.BillingEac)" />
										<input
											v-else-if="config.EacLevel === 'Register'"
											disabled
											:placeholder="getMeterPointBillingEac(config)"
											type="number"
											class="w-100 sh border border-secondary brs text-center" />
									</div>
								</div>
							</div>
						</div>
						<!-- left col4 end -->
						<div class="col-sm-8">
							<div class="row">
								<div class="col-12">
									<p class="font-weight-bold text-left pl-2">EAC Level</p>
								</div>
							</div>
							<div class="row">
								<div class="col-12">
									<div class="btn-group d-block w-100">
										<div class="form-group my-auto">
											<b-form-select
												v-model="config.EacLevel"
												class="form-control"
												name="selection"
												required>
												<option value="MeterPoint">Meter Point</option>
												<option value="Register">Register</option>
											</b-form-select>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="row text-left">
						<div class="col-sm-4">
							<!-- left col4 start -->
							<div class="row">
								<div class="col-12">
									<p
										v-if="activeService.ServiceType === 'Gas'"
										class="font-weight-bold text-left pl-2">
										Billing AQ
									</p>
									<p
										v-else-if="activeService.ServiceType === 'Electricity' && !isHH"
										class="font-weight-bold text-left pl-2">
										Billing EAC
									</p>
								</div>
							</div>
							<div class="row">
								<div class="col-12 pb-2">
									<div
										class="d-block w-100"
										v-if="activeService.ServiceType === 'Gas'">
										<input
											v-model="config.BillingAq"
											type="number"
											class="w-100 sh border border-secondary brs text-center" />
									</div>
									<div
										class="d-block w-100"
										v-else-if="activeService.ServiceType === 'Electricity' && !isHH">
										<div
											v-for="(eac, index) in config.BillingEac"
											:key="index"
											class="row pb-1">
											<div class="col">
												<p class="pl-2">
													{{ getBillingTypeId(eac.RegisterId) }} ({{
														eac.RegisterId
													}})
												</p>
											</div>
											<div class="col">
												<input
													type="number"
													class="w-100 sh border border-secondary brs text-center"
													:disabled="config.EacLevel === 'MeterPoint'"
													v-model="eac.BillingEac" />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- left col4 end -->
						<div class="col-sm-8">
							<div class="col-12">
								<p class="font-weight-bold text-left pl-2">Use</p>
							</div>
							<div class="col-12">
								<div class="btn-group d-block w-100">
									<div class="form-group my-auto">
										<b-form-select
											v-model="config.ApplicationRule"
											class="form-control"
											name="selection"
											required>
											<option value="WhenBillingIsHigherThanIndustry">
												When higher than the Industry {{ units }}
											</option>
											<option value="WhenBillingIsLowerThanIndustry">
												When lower than the Industry {{ units }}
											</option>
											<option value="Always">Always</option>
										</b-form-select>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</b-card>
		</template>

    <template slot="modal-footer">
      <button
          type="submit"
          class="btn btn-hc float-right"
          @click="addCommercialConfig(config)"
          :disabled="submitStatus == 'PENDING' || mappingInvalid">
        Confirm
      </button>
    </template>
  </b-modal>
</template>

<script>
import moment from 'moment';
import { _ } from 'underscore';

// Mixins
import _filters from '@/mixins/filters.js';
import contractsMixin from '@/mixins/contracts/contracts';
import commConfigMixin from '@/mixins/contracts/commercialConfigs/commercialConfigs';

export default {
  mixins: [_filters, contractsMixin, commConfigMixin],
  data() {
    return {
      overrideIndustry: false,
      config: null,
    };
  },
  created() {
    if (this.activeServiceType === 'Electricity') {
      this.config = this.elecConfigTemplate;
    } else if (this.activeServiceType === 'Gas') {
      this.config = this.gasConfigTemplate;
    }

		this.config.EffectiveFrom = moment().format('YYYY-MM-DD');
	},
	mounted() {
		// Sets active commercial config when modal is opened and
		// service type is electricity the active registers can be calculated
		let that = this;
		this.$root.$on('bv::modal::show', (modalId) => {
			if (modalId.componentId === 'addCommercialConfig') {
				if (that.activeServiceType === 'Electricity') {
					that.activeCommercialConfig = _.sortBy(
						that.activeService.ElectricityDetails.CommercialConfigurations,
						'EffectiveFrom'
					).reverse()[0];
					that.config.BillingEac = that.createBillingEacObject();
				}
			}
		});
	},
	computed: {
		pickerDate: {
			get() {
				return moment(this.config.EffectiveFrom).toDate();
			},
			set(v) {
				this.config = {
					...this.config,
					EffectiveFrom: moment(v).format('YYYY-MM-DD'),
				};
			},
		},
		mappingInvalid() {
			return (
				this.isHH &&
				!this.activeServiceBundle.Products.some(
					(p) => p.PriceingApproch == 'ElecHh'
				) &&
				this.config &&
        this.config.HhNhhMappingId === undefined
			);
		},
	},
};
</script>
